import InlineText from '../../InlineEdit/InlineText';
import InlineTextArea from '../../InlineEdit/InlineTextArea';
import { imageScaleUrl } from '../../../helpers/imageScales';
import './chef-about.scss';

const DEFAULTS = {
  eyebrow: 'Aux fourneaux',
  heading: 'Une cuisine de mémoire, *faite à la main.*',
  body: `Au piano depuis l'ouverture, le chef cuisine avec ce qu'il a sous la main : les arrivages du matin, le panier du maraîcher, ce que la saison veut bien donner. Pas d'effets de manche — de la technique, du goût juste, et l'envie qu'on se sente comme à la maison.`,
  signature: '— Le chef et son équipe, À Ciel Ouvert',
};

const renderHeadline = (value: string) => {
  const parts = value.split(/(\*[^*]+\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    return <span key={i}>{part}</span>;
  });
};

const View = (props: any) => {
  const { data, isEditMode, block, onChangeBlock, imageSlot } = props;

  const update = (field: string, value: string) =>
    onChangeBlock(block, { ...data, [field]: value });

  const eyebrow = data.eyebrow ?? (isEditMode ? '' : DEFAULTS.eyebrow);
  const heading = data.heading ?? (isEditMode ? '' : DEFAULTS.heading);
  const body = data.body ?? (isEditMode ? '' : DEFAULTS.body);
  const signature = data.signature ?? (isEditMode ? '' : DEFAULTS.signature);

  const imageUrl =
    data.image && Array.isArray(data.image) && data.image.length > 0
      ? imageScaleUrl(data.image[0], 'large')
      : null;

  const defaultImageElement = imageUrl ? (
    <img src={imageUrl} alt={data.image_alt || ''} loading="lazy" />
  ) : null;

  const slotted = imageSlot?.({
    fieldId: 'image',
    value: data.image,
    element: defaultImageElement,
  });

  return (
    <section className="chef-about" aria-labelledby={`chef-h-${block}`}>
      <div className="shell chef-inner">
        <figure className="chef-portrait">
          {slotted ??
            defaultImageElement ??
            (isEditMode && (
              <div className="chef-portrait-placeholder">
                Sélectionner un portrait du chef
              </div>
            ))}
        </figure>
        <div className="chef-copy">
          <p className="eyebrow chef-eyebrow">
            {isEditMode ? (
              <InlineText
                value={eyebrow}
                onChange={(v) => update('eyebrow', v)}
                renderTag="span"
                placeholder="Sur-titre"
              />
            ) : (
              eyebrow
            )}
          </p>
          <h2 id={`chef-h-${block}`} className="chef-headline">
            {isEditMode ? (
              <InlineText
                value={heading}
                onChange={(v) => update('heading', v)}
                renderTag="span"
                placeholder="Titre du chef (utilisez *...* pour l'italique)"
              />
            ) : (
              renderHeadline(heading)
            )}
          </h2>
          {isEditMode ? (
            <InlineTextArea
              value={body}
              onChange={(v) => update('body', v)}
              renderTag="p"
              renderClassName="chef-bio"
              placeholder="Présentation du chef et de la cuisine."
            />
          ) : (
            body && <p className="chef-bio">{body}</p>
          )}
          {(isEditMode || signature) && (
            <p className="chef-signature">
              {isEditMode ? (
                <InlineText
                  value={signature}
                  onChange={(v) => update('signature', v)}
                  renderTag="span"
                  placeholder="Signature"
                />
              ) : (
                signature
              )}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default View;
